import { Router } from '@angular/router';
import { SolicitacaoService } from './../../../service/solicitacao/solicitacao.service';
import { AreaService } from './../../../service/cliente/area.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ClienteService } from './../../../service/cliente/cliente.service';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { AuthenticationService } from '@alfresco/adf-core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { SolicitacaoModel } from 'app/model/solicitacao/solicitacao.model';
import {setTimeout} from 'timers';
import { PermissoesService } from 'app/service/usuario/permissoes.service';
import {MatTableDataSource, MatPaginator, MatSort} from '@angular/material';
import { ListarNumerosCaixasComponent } from './listar-numeros/listar-numeros-caixas/listar-numeros-caixas.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { SelectionModel } from '@angular/cdk/collections';
import {ENTER, COMMA} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material';
import { ConfigurarContainerComponent } from './configurar-container/configurar-container/configurar-container.component';

@Component({
  selector: 'app-adicionar-solicitacao',
  templateUrl: './adicionar-solicitacao.component.html',
  styleUrls: ['./adicionar-solicitacao.component.scss']
})
export class AdicionarSolicitacaoComponent implements OnInit {

  public usuario;
  public loading = true;
  public solicitacaoForm: FormGroup;
  public submit = false;
  public clientes: ClienteModel[];
  public solicitacaoModel = {} as SolicitacaoModel;
  public areas: any[] = [];
  public disabledCod = true;
  public clienteCacheSolic;
  public areaCacheSolic;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  adm = false;
  acervo = false;
  solicitacao = true;
  solicitacoesConteudo: any[] = [];
  searchSolicitacoesConteudo = false;
  authorityUser = [];
  arrayString: string;
  canChangeStatus = false;
  subAreas: any[] = [];
  showSubAreas = false;
  numeracaoCaixaArray : any[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource = new MatTableDataSource<any[]>([]);
  numerosSelecionados : any[] = [];
  displayedColumns = ['check', 'numero', 'acoes'];
  subAreaIdGlobal;
  showIncludeProtocolo = false;
  solicitacaoId;
  receivedSolicitacao: any = null;
  solicitacaoProcessada = false;
  chooseFormat = true;
  chooseFormatManual = false;
  tabelaOriginal: any[] = [];
  qtdSelected;
  selection = new SelectionModel<any>(true, []);
  selectedRows: any[] = [];
  savedSelections: any[] = [];
  allSelectedRows: any[] = []; // Para armazenar todas as seleções salvas

  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = true;

  containersDoneArray: any[] = [];

  // Enter, comma
  separatorKeysCodes = [ENTER, COMMA];

  fruits = [
    { name: 'Lemon' },
    { name: 'Lime' },
    { name: 'Apple' },
  ];
  constructor(
    private caixaService: CaixaService,
    private fb: FormBuilder,
    private router: Router,
    private clienteService: ClienteService,
    private areaService: AreaService,
    private _snackBar: MatSnackBar,
    private solicitacaoService: SolicitacaoService,
    public dialog: MatDialog,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer) {
      iconRegistry.addSvgIcon('protocolarIcon', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/icons/emitir_protocolo.svg'));
      iconRegistry.addSvgIcon('printIcon', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/icons/imprimir_protocolo.svg'));
     }

  ngOnInit() {

    this.solicitacaoForm = this.fb.group({
      area: [null, Validators.required],
      cliente: [null, Validators.required],
      responsavelAbertura: ['', Validators.required],
      dataAbertura: [''],
      dataFechamento: [''],
      tipoDaSolicitacao: ['', Validators.required],
      dadosAdicionais: [''],
      solicitarConteudoId: [''],
      subAreaOrigem: [null],
      formarContainer: [false],
      qtdCaixasContainer: [null]
    });
    this.solicitacaoService.currentData.subscribe(data => {
      if (data != null) {
        this.receivedSolicitacao = data.solicitacao;
        this.getSolicitacaoUnica(this.receivedSolicitacao.id);
        this.showSubAreas = true;
        this.solicitacaoId = this.receivedSolicitacao.id;
      } else {
        this.showSubAreas = false;
        this.solicitacaoId = undefined;
        this.solicitacaoProcessada = false;
        this.receivedSolicitacao = null;
      }
    });

    
    this.getUserResponsavel(sessionStorage.getItem('ACS_USERNAME'));
    this.listarClientesUsuario();
    this.solicitacaoForm.get('area').disable();
    this.buscarCamposEmCache();
    this.getAuthority();
  }

  buscarCamposEmCache() {
    const cliente = localStorage.getItem('RM_CLIENTE_SOLIC_CACHE');
    const area = localStorage.getItem('RM_AREA_SOLIC_CACHE');
    if ((cliente !== null) && (area !== null)) {
      this.solicitacaoForm.get('cliente').setValue(JSON.parse(cliente));
      this.solicitacaoModel.cliente = JSON.parse(cliente);
      this.solicitacaoForm.get('area').enable();
      const clienteId = JSON.parse(cliente).id;
      this.listarAreasCliente(clienteId);
      this.solicitacaoForm.get('area').setValue(JSON.parse(area));
      this.solicitacaoModel.area = JSON.parse(area);
      this.disabledCod = false;

      this.listarSubAreas(this.solicitacaoModel.area.id);
    }
  }

  getUserResponsavel(userId: string) {
    this.caixaService.getUsuarioCaixa(userId).subscribe(data => {
      this.usuario = data;
      this.solicitacaoForm.get('responsavelAbertura').setValue(this.usuario.nome);
      this.loading = false;
    }, err => {
      console.error(err);
    });
  }

  onSubmit() {
    this.submit = true;
    this.saveSolicitacao();
  }

  compararClienteEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.nome === obj2.nome && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararAreaEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararSubAreaEditCaixa(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  onChange(event) {
    this.clienteCacheSolic = this.solicitacaoForm.get('cliente').value;
    localStorage.setItem('RM_CLIENTE_SOLIC_CACHE', JSON.stringify(this.clienteCacheSolic));
    const idCliente = (this.solicitacaoForm.get('cliente').value).id;
    //this.idCliente = idCliente;
    //this.selectCliente = false;
    this.disabledCod = false;
    this.solicitacaoForm.get('area').enable();
    this.listarAreasCliente(idCliente);
    this.solicitacaoForm.get('area').enable();
    this.disabledCod = false;
    //this.listaArea = true;
  }

  onChangeArea() {
    this.areaCacheSolic = this.solicitacaoForm.get('area').value;
    localStorage.setItem('RM_AREA_SOLIC_CACHE', JSON.stringify(this.areaCacheSolic));

    this.listarSubAreas(this.areaCacheSolic.id);
  }

  saveSolicitacao() {
    if (this.solicitacaoForm.valid) {
      this.solicitacaoForm.get('area').enable();
      this.solicitacaoService.adicionarSolicitacao(this.solicitacaoForm.value).subscribe(data => {
        this.solicitacaoId = data.id;
        this.openSnackBarSuccess(`Solicitação de ${data.tipoDaSolicitacao} salva com sucesso !`);
        if (data.tipoDaSolicitacao === 'PROTOCOLO') {
          this.showIncludeProtocolo = true;  
        } else {
          const idCrypt = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(data.id), 'pcdoc').toString());
          setTimeout(() => {
              this.router.navigate(['/solicitacao', idCrypt]);
          }, 3000);
        }
      }, err => {
        console.error(err);
        this.openSnackBarError(`Erro !`);
      });
    } else {
      this.openSnackBarError('Preencha todos os campos obrigatórios !');
    }

  }

  reset() {
    this.submit = false;
    this.disabledCod = true;
    this.solicitacaoForm.get('cliente').reset();
    this.solicitacaoForm.get('area').reset();
    this.solicitacaoForm.get('area').disable();
    this.solicitacaoForm.get('dataAbertura').reset();
    this.solicitacaoForm.get('dataFechamento').reset();
    this.solicitacaoForm.get('tipoDaSolicitacao').reset();
  }

  listarAreasCliente(idCliente: number) {
    this.areaService.getAreasUsuarioCliente(idCliente).subscribe(data => {
      this.areas = data;
      if (this.areas.length === 1) {
        this.solicitacaoForm.get('area').setValue(this.areas[0]);
      }
    }, err => {
      console.error(err);
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    });
  }

  buscarMinhasSolicitacoes() {
    this.solicitacaoService.buscarSolicitacoesPorMinhasEmpresas().subscribe(data => {
      this.solicitacoesConteudo = data.success ? data.result : [];
      if (data.success) {
        this.searchSolicitacoesConteudo = true;
      } else {
        this.searchSolicitacoesConteudo = false;
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  buscarMinhasSolicitacoesDevolucao() {
    this.solicitacaoService.buscarSolicitacoesPorMinhasEmpresasParaDevolucao().subscribe(data => {
      this.solicitacoesConteudo = data.success ? data.result : [];
      if (data.success) {
        this.searchSolicitacoesConteudo = true;
      } else {
        this.searchSolicitacoesConteudo = false;
      }
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  buscarSolicitacaoUnica(id: number) {
    this.solicitacaoService.buscarSolicitacoesUnica(id).subscribe(data => {
      if (data.success) {
        this.clientes.forEach(cliente => {
          if (cliente.id === data.result.cliente) {
            this.solicitacaoForm.get('cliente').setValue(cliente);
            this.listarAreasCliente(cliente.id);
          }
        });
        setTimeout(() => {
          this.areas.forEach(area => {
            if (area.id === data.result.area) {
              this.solicitacaoForm.get('area').setValue(area);
            }
          });
        }, 1000);
        this.solicitacoesConteudo.forEach(solic => {
          if (solic.id.toString() === id.toString()) {
            this.solicitacaoForm.get('dadosAdicionais').setValue(solic.objetoRequisicao);
          }
        });
      } else {
        this.openSnackBarError(data.message);
      }
    }, err => {
      console.error(err);
    });
  }
  selecionarTipoSolic(event: string): void {
    if (event === 'REQUISICAO_CONTEUDO') {
      this.buscarMinhasSolicitacoes();
    }
    if (event === 'DEVOLUCAO_CONTEUDO') {
      this.loading = true;
      this.buscarMinhasSolicitacoesDevolucao();
    }

    if (event === 'PROTOCOLO') {
      this.showSubAreas = true;
    } else {
      this.showSubAreas = false;
    }
  }

  selecionarSolicitarConteudo(event: any): void {
    this.solicitacaoForm.get('solicitarConteudoId').setValue(Number(event.toString()));
    this.buscarSolicitacaoUnica(event);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

  getAuthorityUser() {
    if (this.authorityUser.includes("MUDAR_STATUS")) {
      this.canChangeStatus = true;
    }
  }

  getAuthority() {
    const store = sessionStorage.getItem('authority');
    const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
    this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    if (this.arrayString.includes('CHANGE_STATUS_SOLICITACAO')) {
        this.canChangeStatus = true;
    }     
  }

  listarSubAreas(areaId: any) {
    this.areaService.getSubAreaByAreaId(areaId).subscribe(data => {
      this.subAreas = data.result;
      this.loading = false;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  selecionarSubarea() {
    this.subAreaIdGlobal = this.solicitacaoForm.get('subAreaOrigem').value.id;
  }

  selectNumeros() {
    const dialogRef = this.dialog.open(ListarNumerosCaixasComponent, {
      data: {id: this.subAreaIdGlobal, solicitacaoId: this.solicitacaoId, qtd: this.qtdSelected},
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (!!result) {
        this.numerosSelecionados = result;
        //const groupedData = this.groupData(result);
        //this.dataSource = new MatTableDataSource(groupedData);
        //this.dataSource = new MatTableDataSource(result);
        this.tabelaOriginal = this.dataSource.data;
        if (!this.chooseFormat) {
          this.saveSelection(this.qtdSelected);
        }
      }
    });
  }

  configContainer() {
    console.log(this.dataSource.data);
    const dialogRef = this.dialog.open(ConfigurarContainerComponent, {
      data: {numeros: this.dataSource.data, solicitacaoId: this.solicitacaoId, qtd: this.solicitacaoForm.get('qtdCaixasContainer').value, numerosNovos: ''},
      width: '70%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      this.saveSelectionOrganize(this.qtdSelected, result);
    });
  }

  getSolicitacaoUnica(solicitacaoId: Number) {
    this.solicitacaoService.getSolicitacao(solicitacaoId).subscribe(data => {
      this.solicitacaoForm.patchValue({
        area: data.area,
        cliente: data.cliente,
        responsavelAbertura: data.responsavelAbertura,
        dataAbertura: data.dataAbertura,
        dataFechamento: data.dataFechamento,
        tipoDaSolicitacao: data.tipoDaSolicitacao,
        dadosAdicionais: data.dadosAdicionais,
        subAreaOrigem: data.subAreaOrigem,
        formarContainer: data.formarContainer,
        qtdCaixasContainer: data.qtdCaixasContainer
      });
      
      this.qtdSelected = !!data.qtdCaixasContainer ? data.qtdCaixasContainer : null;

      if (data.dataFechamento != null) {
        this.solicitacaoProcessada = true;
      }
      this.listarSubAreas(data.area.id);
      this.onChange(data);

      if (data.numeracaoCaixas != null) {
        //const groupedData = this.groupData(data.numeracaoCaixas);
        if (data.organizacaoContainers.length > 0) {
          this.dataSource = new MatTableDataSource(data.organizacaoContainers);
        } else {
          this.dataSource = new MatTableDataSource(data.numeracaoCaixas);
        }
        this.tabelaOriginal = this.dataSource.data;
      }

      this.subAreaIdGlobal = this.solicitacaoForm.get('subAreaOrigem').value.id;
    }, err => {
      console.error(err);
    });
  }

  deleteNr(numeracao: any) {
    console.log(numeracao);
    let numeros = [];
    numeros.push(Number(numeracao.id1));
    if (numeracao.id2) {
      numeros.push(Number(numeracao.id2));
    }
    if (numeracao.id3) {
      numeros.push(Number(numeracao.id3));
    }
    this.deleteNrRequest(numeros);
    this.removeRow(numeracao.id1);
  }

  removeRow(id: any) {
    const index = this.dataSource.data.findIndex((item: any) => item.id1 === id);
    if (index >= 0) {
      this.dataSource.data.splice(index, 1);
      this.dataSource = new MatTableDataSource(this.dataSource.data);
    }
  }

  deleteNrRequest(numeros: any) {
    this.solicitacaoService.deleteNumeroSolicitacao(numeros, this.solicitacaoId).subscribe(() => {
      // do nothing
    }, err => {
      console.error(err);
    });
  }

  groupData(data: any[]): any[] {
    const groupedData = [];
    for (let i = 0; i < data.length; i += 2) {
      if (data[i + 1]) {
        groupedData.push({ idGroup: `${data[i].valor} - ${data[i + 1].valor}`, id1: `${data[i].id}`, id2: `${data[i + 1].id}` });
      } else {
        groupedData.push({ idGroup: `${data[i].valor}`, id1: `${data[i].id}` });
      }
    }
    return groupedData;
  }

  protocolar() {
    this.solicitacaoService.protocolarSolicitacao(this.solicitacaoId).subscribe(() => {
      this.openSnackBarSuccess('Protocolado com sucesso !');
      //this.router.navigate(['/solicitacoes']);
      this.solicitacaoProcessada = true;
    }, err => {
      console.error(err);
    });
  }

  relatorioEliminacao() {
    this.solicitacaoService.downloadProtocoloSolicitacao(this.solicitacaoId).subscribe(data => {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    }, err => {
      console.error(err);
    });
  }

  formarContainer(event: any) {
    console.log(event);
    if (event.checked) {
      this.chooseFormat = false;
    } else {
      this.chooseFormat = true;
    }
  }

  formarContainerManual(event: any) {
    console.log(event);
    if (event.checked) {
      this.chooseFormatManual = true;
    } else {
      this.chooseFormatManual = false;
    }
  }

  chooseFormatContainer(event: any) {
    this.qtdSelected = event.value;
    // let dadosFormatados = [];
    // let dados = [];
    // dados = this.tabelaOriginal;
    // dadosFormatados = this.criarNovosArrays(dados, event.value);
    // console.log(dadosFormatados);
    //this.dataSource = new MatTableDataSource(dadosFormatados);
  }

  

  add(event: MatChipInputEvent): void {
    let input = event.input;
    let value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.fruits.push({ name: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(container: any): void {
    let index = this.containersDoneArray.indexOf(container);

    if (index >= 0) {
      this.containersDoneArray.splice(index, 1);
    }
  }

  saveSelection(qtdSelected: any): void {

    if (qtdSelected === 1) {
      for (let i = 0; i < this.numerosSelecionados.length; i ++) {
        this.containersDoneArray.push(
          {
            id: null,
            id1: this.numerosSelecionados[i].id,
            id2: null,
            id3: null,
            valor: this.createValorToSend1(i),
            solicitacaoId: this.solicitacaoId
          }
        );
      }
    }

    if (qtdSelected === 2) {
      for (let i = 0; i < this.numerosSelecionados.length; i += 2) {
        this.containersDoneArray.push(
          {
            id: null,
            id1: this.numerosSelecionados[i].id,
            id2: this.numerosSelecionados[i+1].id,
            id3: null,
            valor: this.createValorToSend(i),
            solicitacaoId: this.solicitacaoId
          }
        );
      }
    }

    if (qtdSelected === 3) {
      for (let i = 0; i < this.numerosSelecionados.length; i += 3) {
        this.containersDoneArray.push(
          {
            id: null,
            id1: this.numerosSelecionados[i].id,
            id2: this.numerosSelecionados[i+1].id,
            id3: this.numerosSelecionados[i+2].id,
            valor: this.createValorToSend3(i),
            solicitacaoId: this.solicitacaoId
          }
        );
      }
    }
    this.dataSource = new MatTableDataSource(this.containersDoneArray);
    this.salvarOrganizacao();
  }

  saveSelectionOrganize(qtdSelected: any, result: any[]): void {
    this.containersDoneArray = [];
    if (qtdSelected === 1) {
      for (let i = 0; i < result.length; i++) {
        this.containersDoneArray.push(
          {
            id: result[i].id,
            id1: result[i].id1,
            id2: null,
            id3: null,
            valor: result[i].valor,
            solicitacaoId: this.solicitacaoId
          }
        );
      }
    }

    if (qtdSelected === 2) {
      for (let i = 0; i < result.length; i++) {
        this.containersDoneArray.push(
          {
            id: result[i].id,
            id1: result[i].id1,
            id2: result[i].id2,
            id3: null,
            valor: result[i].valor,
            solicitacaoId: this.solicitacaoId
          }
        );
      }
    }

    if (qtdSelected === 3) {
      for (let i = 0; i < result.length; i++) {
        this.containersDoneArray.push(
          {
            id: result[i].id,
            id1: result[i].id1,
            id2: result[i].id2,
            id3: result[i].id3,
            valor: result[i].valor,
            solicitacaoId: this.solicitacaoId
          }
        );
      }
    }
    this.dataSource = new MatTableDataSource(this.containersDoneArray);
  }

  createValorToSend(index: number) {
    return this.numerosSelecionados[index].valor+"-"+this.numerosSelecionados[index+1].valor
  }

  createValorToSend3(index: number) {
    return this.numerosSelecionados[index].valor+"-"+this.numerosSelecionados[index+1].valor+"-"+this.numerosSelecionados[index+2].valor;
  }

  createValorToSend1(index: number) {
    return this.numerosSelecionados[index].valor;
  }

  salvarOrganizacao() {
    let body = {
      organizacaoContainer: [],
      organizacaoContainerList: this.containersDoneArray
    }
    this.solicitacaoService.salvarOrganizacaoContainer(body, this.solicitacaoId).subscribe(data => {
      console.log(data);
    }, err => {
      console.error(err);
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/adicionar-solicitacao/adicionar-solicitacao.component.ts